import React, { FC } from 'react';
import styled from 'styled-components';
import { User } from 'api/models';
import { Avatar } from 'components/atoms/avatar';
import { fullName } from 'utils/full-name';

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  gap: var(--spacing-02);
`;

export const UserNameWithAvatar: FC<{ user: User }> = ({ user }) => {
  return (
    <Wrapper>
      <Avatar size="small" name={fullName(user)} src={user?.photoUrl} />{' '}
      {fullName(user)}
    </Wrapper>
  );
};
